import * as Redux from 'redux'
import { MCommonProduct } from '@Models/common.model'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Grid } from '@mui/material'
import { useHistory } from 'react-router'
import ClientMyVaultActions from '@ClientActions/my-vault.action'
import Product from '@Components/Product/Product'
import FirearmModal from './FirearmModal'
import InstructionModal from './InstructionModal'
import LostOfStolen from './LostOrStolen'
import { IFirearms } from '../../../models/client/firearm.model'

interface IFirearmsProps {
    data: any
    submitItemLostOrStolen?: any
    submitChanged?: () => void
    itemType: string
    getInstructionLetter?: any
}

const Firearms = (props: IFirearmsProps) => {
    // core section
    const {
        data,
        submitItemLostOrStolen,
        submitChanged,
        itemType,
        getInstructionLetter,
    } = props
    const newData = data?.map(
        (item: any) => new MCommonProduct({ ...item, checkbox: true })
    )
    const history = useHistory()

    // states section
    const [showFirearmModal, setShowFirearmModal] = useState(false)
    const [showLostStolenModal, setLostStolenShowModal] = useState(false)
    const [showInstruction, setShowInstruction] = useState(false)
    const [lostOrStolenData, setLostOrStolenData] = useState({})
    const [firearmData, setFirearmData] = useState({})
    const [radioValue, setRadioValue] = useState('')

    const handleProductAction = (action: string, item: any) => {
        if (action === 'view-detail') {
            setShowFirearmModal(true)
            setFirearmData(item)
            // history.push(`/detail-firearm/${item?.id}`)
        } else {
            setLostOrStolenData(item)
            setLostStolenShowModal(true)
        }
    }

    const onClickModal = (type: string, payload: any) => {
        if (type === 'INSTRUCTION') {
            const body = {
                status: payload?.status,
            }

            if (submitItemLostOrStolen)
                submitItemLostOrStolen(
                    payload?.id,
                    body,
                    (response: string) => {
                        if (response === 'success') {
                            setShowInstruction(true)
                            setLostStolenShowModal(false)
                            getInstructionLetter(payload?.id)
                        }
                        if (submitChanged) {
                            submitChanged()
                            setRadioValue('')
                        }
                    }
                )
        }
    }

    // useEffect(() => {
    //     setShowInstruction(true)
    // }, [])

    return (
        <>
            {/* modal section */}
            <LostOfStolen
                radioValue={radioValue}
                setRadioValue={setRadioValue}
                item={lostOrStolenData}
                open={showLostStolenModal}
                onClose={() => setLostStolenShowModal(false)}
                onClickAction={(type, payload) => {
                    onClickModal(type, payload)
                }}
            />
            {/* firearm modal section */}
            <FirearmModal
                itemType={itemType}
                item={firearmData}
                open={showFirearmModal}
                onClose={() => setShowFirearmModal(false)}
            />
            <InstructionModal
                open={showInstruction}
                onClose={() => setShowInstruction(false)}
            />
            {newData?.map((item: IFirearms) => (
                <React.Fragment key={`${item?.id}_gun_list_item`}>
                    <Grid item md={6} sm={12}>
                        <Product
                            checkbox={false}
                            product={item}
                            // action
                            additionalInfo
                            actionTitle="Lost or Stolen"
                            getActions={handleProductAction}
                            page="MY_VAULT"
                            productType={item?.type as any}
                        />
                    </Grid>
                </React.Fragment>
            ))}
        </>
    )
}
const mapStateToProps = (store: any) => {
    return {
        statusChangeItem: store?.client?.myVault?.item,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        submitItemLostOrStolen: (id: string, payload: any, cb: any) => {
            dispatch(
                ClientMyVaultActions.updateStolenOrLost(id, payload, cb) as any
            )
        },
        getInstructionLetter: (id: string) => {
            dispatch(ClientMyVaultActions.getInstructionLetter(id) as any)
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Firearms)
